module.exports = __webpack_public_path__ + "static/media/img.e6a4ba5c.png";